<template>
  <ConnectionSegment
    :title="$t('connection-manager.connections.google-calendar.title')"
    :description="$t('connection-manager.connections.google-calendar.description')"
  >
    <GoogleCalendarWrapper :feature-disabled="featureDisabled">
      <template
        #activator="{
          isConnected,
          loading,
          connect,
          settings,
          disconnect,
          dialogActivatorProps,
          verifiedText,
        }"
      >
        <Connection
          :active="isConnected"
          :disabled="featureDisabled"
          :image="googleCalendarImage"
          :loading="loading"
          :dialog-activator-props="dialogActivatorProps"
          connect-tracking-id="google_calendar_connect"
          settings-tracking-id="google_calendar_settings"
          disconnect-tracking-id="google_calendar_disconnect"
          :verified-text="verifiedText"
          :connection-button-text="'settings.calendar-sync.connect-google'"
          show-settings
          @connect="connect"
          @settings="settings"
          @disconnect="disconnect"
        />
      </template>
    </GoogleCalendarWrapper>
  </ConnectionSegment>
</template>

<script lang="ts" setup>
import googleCalendarImage from '@/assets/img/google-calendar.svg'

import Connection from './Connection.vue'
import ConnectionSegment from './ConnectionSegment.vue'
import GoogleCalendarWrapper from './googleCalendarWrapper/index.vue'

type Props = {
  featureDisabled?: boolean
}

withDefaults(defineProps<Props>(), {
  featureDisabled: false,
})
</script>
